import React, { ReactNode } from 'react';

import { FlexLayout } from '@zapier/common-components';
import Button from 'app/common/components/Button';

type Props = {
  children: ReactNode;
  id: number;
  onToggleTeamsAutoUpgrade: (
    id: number,
    shouldAutoUpgradeToTeams: boolean
  ) => void;
  shouldAutoUpgradeToTeams: boolean;
  shouldRenderButton: boolean;
  size: 'small' | 'medium' | 'large';
};

export const ToggleTeamsUpgradeButton = ({
  children,
  id,
  onToggleTeamsAutoUpgrade,
  shouldAutoUpgradeToTeams,
  shouldRenderButton,
  size,
  ...props
}: Props) => {
  const text = shouldAutoUpgradeToTeams
    ? 'Disable Auto-Upgrade'
    : 'Enable Auto-Upgrade';

  const toggleButton = shouldRenderButton && (
    <Button
      {...props}
      kind="as-link"
      onClick={() => {
        onToggleTeamsAutoUpgrade(id, shouldAutoUpgradeToTeams);
      }}
    >
      {text}
    </Button>
  );

  return (
    <FlexLayout justify={size === 'large' ? 'space-between' : 'center'}>
      {children} {toggleButton}
    </FlexLayout>
  );
};
